import FileAPI from '@/apis/other/fileAPI'
import CrudBase from '@/stores/crudBase.js'

const crudBase = new CrudBase('File', FileAPI)
export default {
  namespaced: true,
  state: {
    ...crudBase.state,
    _config: {
      field: {
        key: 'Id',
      },
    },
    fileManager: [],
  },
  mutations: {
    ...crudBase.mutations,
  },
  getters: {},
  actions: {
    ...crudBase.actions,
    /**
     * @decription Upload file lên MinIO
     */
    async uploadFiles (context, params) {
      await FileAPI.uploadFiles(params)
    },

    /**
     * copy file ảnh vào thư mục chính
     * @param {*} context
     * @param {*} params
     */
    async copyFiles (context, params) {
      await FileAPI.copyFiles(params)
    },

    /**
     * @description Lấy url file
     * @param {*} context
     * @param {*} params
     */
    async getFileUrl (context, params) {
      return FileAPI.getFileUrl(params)
    },

    /**
     * @description Lấy url preview file
     * @param {*} context
     * @param {*} params
     */
    async getPreviewUrl (context, params) {
      return FileAPI.getPreviewUrl(params)
    },
  },
}
